import React, { useEffect, useRef, useState } from "react";
import FilterByStatus from "./FilterByStatus";
import FilterByTime from "./FilterByTime";
import { TasksListComponent } from "../TasksListComponent";

export default function Filter(props) {
  const filterRef = useRef();

  const [status, setStatus] = useState("status");
  const [openFilter, setOpenFilter] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const {
    data,
    filterMenu,
    setFilterMenu,
    setTimeFilterMenu,
    timeFilterMenu,
    setShowTaskFilterMenu,
    isButtonDisable,
  } = props;

  useEffect(() => {
    if (openFilter === false) {
      setOpenFilter(true);
    }
  }, []);

  const switchTaskView = () => {
    switch (status) {
      case "status":
        return (
          <FilterByStatus
            data={data}
            filterMenu={filterMenu}
            setFilterMenu={setFilterMenu}
            ref={filterRef}
            setFilteredData={setFilteredData}
            setShowTaskFilterMenu={setShowTaskFilterMenu}
          />
        );
      case "time":
        return (
          <FilterByTime
            data={data}
            setTimeFilterMenu={setTimeFilterMenu}
            timeFilterMenu={timeFilterMenu}
            ref={filterRef}
          />
        );
      default:
        return null;
    }
  };

  const handleParentClear = () => {
    if (filterRef.current) {
      filterRef.current.handleClearAll();
    }
  };

  return (
    <div>
      <div
        className={`flex flex-col overflow-visible w-full outline-none text-theme-fg-2 top-0 right-0 border-none`}
        tabIndex="-1"
      >
        <div className="flex items-center justify-between pb-4 pr-4">
          <header className="border-b border-theme-cream-3 flex grow items-start justify-between">
            <div>
              <button
                onClick={() => setStatus("status")}
                className={`
             ${
               status == "status"
                 ? "text-theme-fg-1 border-theme-ink border-b-2"
                 : "text-theme-fg-3 border-transparent border-b-2"
             }
               mr-8 font-title text-sm pb-2 font-normal`}
              >
                By Task
              </button>
              <button
                onClick={() => setStatus("time")}
                className={`
             ${
               status == "time"
                 ? "text-theme-fg-1 border-theme-ink border-b-2"
                 : "text-theme-fg-3 border-transparent border-b-2"
             }
              mr-8 font-title text-sm  pb-2 font-normal`}
              >
                By Time
              </button>
            </div>

            <div className="cursor-pointer">
              <button className="text-xs font-bold text-theme-accent" onClick={handleParentClear}>
                Clear Filter
              </button>
            </div>
          </header>
        </div>
        <div className="flex-grow py-4 pt-2 overflow-y-auto">
          {switchTaskView()}
        </div>

        {filteredData && filteredData.length > 0 ? (
          <div className="flex flex-col gap-2">
            {filteredData.map((task, _index) => (
              <div id={task._id} key={task._id}>
                {task.status_name !== "DELETE" && (
                  <TasksListComponent
                    data={data}
                    item={task}
                    taskTime={task.timelog}
                    isButtonDisable={isButtonDisable}
                  />
                )}
              </div>
            ))}
          </div>
        )  : <p className="text-theme-fg-3">No task to show</p>}
      </div>
    </div>
  );
}
